import { Grid, TextField } from "@mui/material";
import React from "react";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";

import { Container, Input } from "./styles";
import AutocompleteDropdown from "../../../../../reusable-components/AutocompleteDropdown/AutocompleteDropdown";

import { EmployeeDependentTypesApiService } from "../../../../../services/employee-dependent-types/employee-dependent-types-api.service";
import { intlFormatDateShort } from "../../../../../utils/time-utils";

const DependentMutationInput = ({
  originalValue,
  mutationValue,
  handleChangeMutation,
  field,
  mutationObject = null,
}) => {
  const { i18n, t } = useTranslation();
  const tRP = "components.data_and_documents"; // tRP - translation root path

  return (
    <Container>
      <Input
        disabled
        label={`${t(`${tRP}.common_keys.original`)} ${t(`${tRP}.employee_data.employee_dependents.fields.${field}`)}`}
        value={field === "birthDate" ? intlFormatDateShort(originalValue) : originalValue ?? ""}
      />
      {field === "dependentType" ? (
        <AutocompleteDropdown
          labelKey={`${t(`${tRP}.common_keys.new`)} ${t(`${tRP}.employee_data.employee_dependents.fields.${field}`)}`}
          field="dependentType"
          serviceApi={new EmployeeDependentTypesApiService()}
          handleChange={handleChangeMutation}
          propsItem={mutationObject}
          sxProps={{ width: "40%" }}
        />
      ) : field === "birthDate" ? (
        <Grid>
          <DatePicker
            selected={mutationValue ? new Date(mutationValue) : null}
            onChange={(date) => {
              // convert whe date value to compensate UTC offset
              const theDate = date as Date;
              const offsetMiliseconds = theDate.getTimezoneOffset() * 60000;
              const value = new Date(theDate.getTime() - offsetMiliseconds);
              handleChangeMutation(field, value);
            }}
            locale={i18n.language}
            customInput={
              <TextField
                variant="outlined"
                label={`${t(`${tRP}.common_keys.new`)} ${t(
                  `${tRP}.employee_data.employee_dependents.fields.${field}`
                )}`}
              />
            }
            dateFormat="yyyy-MM-dd"
            popperPlacement="top"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
          />
        </Grid>
      ) : (
        <Input
          label={`${t(`${tRP}.common_keys.new`)} ${t(`${tRP}.employee_data.employee_dependents.fields.${field}`)}`}
          value={mutationValue ?? ""}
          onChange={(e) => handleChangeMutation(field, e.target.value)}
        />
      )}
    </Container>
  );
};

export default DependentMutationInput;
